import React from "react";
import "./DashboardLoader.css";

const DashboardLoader = () => {
  return (
    <div className="dashboard-loader">
      <div className="loader-container">
        <div className="loader-spinner"></div>
        <div className="loader-text">
          <h2>Loading data...</h2>
          <p>Retrieving data from the database</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardLoader; 